import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
const API_URL = process.env.REACT_APP_API_URL;
// Define a service using a base URL and expected endpoints
export const horseApi = createApi({
  reducerPath: 'horseApiQuery',
  baseQuery: fetchBaseQuery({
     baseUrl: `${API_URL}`
    }),
 
  endpoints: (builder) => ({
    getHorse: builder.query({
      query: () => 'Horse'
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetHorseQuery } = horseApi